<template>
  <table
    ref="table"
    class="c-table c-table--prefecture"
    :class="[classes ? classes : '']"
  >
    <thead>
      <tr>
        <th class="c-table__cell--center u-w34"></th>
        <th class="c-table__cell--center u-w116">都道府県</th>
        <th class="c-table__cell--center u-w116">配信対象数</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="c-table__cell--rank">1</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
      </tr>
      <tr>
        <td class="c-table__cell--rank">2</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
      </tr>
      <tr>
        <td class="c-table__cell--rank">3</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
      </tr>
      <tr>
        <td class="c-table__cell--rank">4</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
      </tr>
      <tr>
        <td class="c-table__cell--rank">5</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
      </tr>
      <tr>
        <td class="c-table__cell--rank">6</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
      </tr>
      <tr>
        <td class="c-table__cell--rank">7</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
      </tr>
      <tr>
        <td class="c-table__cell--rank">8</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
      </tr>
      <tr>
        <td class="c-table__cell--rank">9</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
      </tr>
      <tr>
        <td class="c-table__cell--rank">10</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
        <td class="c-table__cell--center c-table__cell--middle">-</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import * as d3 from 'd3';

export default {
  props: {
    classes: { type: String, required: false },
  },
  data() {
    return {
      chartElements: {
        table: null,
      },
      columns: {},
      period: {},
      sort: {},
      tooltipData: {
        prefectureId: '',
      },
    }
  },

  mounted: function() {
    this.chartElements.table = d3.select(this.$refs.table);
  },

  methods: {
    init: function(data, period, sort) {
      // 日付、表示カラム、ソート指定を保存
      this.period = period;
      this.sort = sort;

      // prefectureIdをidというキーで追加
      data.items = data.items.map((item) => {
        item.id = item.prefectureId;
        return item;
      })

      // 都道府県データを設定
      const tableData = data.items;

      // テーブル表示データのソート処理
      tableData.sort(function (a, b) {
        return (sort.type.toLowerCase() == 'asc') ? a[sort.key] - b[sort.key] : b[sort.key] - a[sort.key] ;
      });

      // フォーマッター設定
      const numberFormatter = new Intl.NumberFormat('ja-JP', {
        setMaximumFractionDigits: 1,
      });
      const percentFormatter = new Intl.NumberFormat('ja-JP', {
        style: 'percent',
        maximumFractionDigits: 2,
      });

      // 地域別配信数テーブル更新
      this.chartElements.table
        .selectAll('tbody tr')
        .each((d, i, nodes) => {
          const summary = tableData[i];

          // 表示用データ作成
          const displayData = {
            prefecture: summary.prefecture,
            delivery: numberFormatter.format(summary.delivery),
            impression: numberFormatter.format(summary.impression),
            click: numberFormatter.format(summary.click),
            ctr: Number(percentFormatter.format(summary.ctr).replace(',', '').replace('%', '')).toFixed(2),
          }

          // プロパティ値には、実数値を設定
          d3.select(nodes[i])
            .property('prefecture', summary.prefecture)
            .property('click', summary.click)
            .property('ctr', summary.ctr)
            .property('delivery', summary.delivery)
            .property('impression', summary.impression);

          nodes[i].children[1].textContent = displayData.prefecture;
          nodes[i].children[2].textContent = displayData.delivery;
        })
    },
  },
}
</script>
